import {Action} from '@ngrx/store';
import {DickerSelectListItem} from '../models/check-out.model';

export enum DigitalWalletActionTypes {
  Load = '[DigitalWallet] Load',
  LoadSuccess = '[DigitalWallet] LoadSuccess',
  LoadFailure = '[DigitalWallet] LoadFailure',

  // Enable = '[DigitalWallet] Enable',
  // EnableSuccess = '[DigitalWallet] EnableSuccess',
  // EnableFailure = '[DigitalWallet] EnableFailure',
  //
  // Disable = '[DigitalWallet] Disable',
  // DisableSuccess = '[DigitalWallet] DisableSuccess',
  // DisableFailure = '[DigitalWallet] DisableFailure',
}


export class LoadDigitalWallet implements Action {
  readonly type = DigitalWalletActionTypes.Load;

}

export class LoadDigitalWalletSuccess implements Action {
  readonly type = DigitalWalletActionTypes.LoadSuccess;

  constructor(public payload: DickerSelectListItem[]) {
  }
}

export class LoadDigitalWalletFailure implements Action {
  readonly type = DigitalWalletActionTypes.LoadFailure;

  constructor(public payload: string) {
  }
}

// export class EnableDigitalWallet implements Action {
//   readonly type = DigitalWalletActionTypes.Enable;
//
//   constructor(public payload: string) {
//   }
//
// }
//
// export class EnableDigitalWalletSuccess implements Action {
//   readonly type = DigitalWalletActionTypes.EnableSuccess;
//
//   constructor(public payload: string) {
//   }
// }
//
// export class EnableDigitalWalletFailure implements Action {
//   readonly type = DigitalWalletActionTypes.EnableFailure;
//
// }
//
// export class DisableDigitalWallet implements Action {
//   readonly type = DigitalWalletActionTypes.Disable;
//
//   constructor(public payload: string) {
//   }
//
// }
//
// export class DisableDigitalWalletSuccess implements Action {
//   readonly type = DigitalWalletActionTypes.DisableSuccess;
//
//   constructor(public payload: string) {
//   }
//
// }
//
// export class DisableDigitalWalletFailure implements Action {
//   readonly type = DigitalWalletActionTypes.DisableFailure;
//
// }

export type DigitalWalletActions =
  LoadDigitalWallet
  | LoadDigitalWalletSuccess
  | LoadDigitalWalletFailure
  // | EnableDigitalWallet
  // | EnableDigitalWalletSuccess
  // | EnableDigitalWalletFailure
  // | DisableDigitalWallet | DisableDigitalWalletSuccess | DisableDigitalWalletFailure
